import * as Sentry from '@sentry/react';
import type { Project as Tenant } from '@vincerosoft/assessfluence-types';
import { appEnv, sentryConfig } from './env';

export const isSentryRuntimeEnabled =
  import.meta.env.PROD && Boolean(sentryConfig.dsn) && appEnv === 'production';

export function initSentry(): void {
  if (!isSentryRuntimeEnabled) {
    return;
  }

  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: appEnv,
    release: sentryConfig.release,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: sentryConfig.tracesSampleRate,
    replaysSessionSampleRate: sentryConfig.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryConfig.replaysOnErrorSampleRate,
    sendDefaultPii: true
  });
}

export function setSentryTenantContext(tenant: Tenant): void {
  if (!isSentryRuntimeEnabled) {
    return;
  }

  Sentry.setTag('tenant.domain', tenant.domain);
  Sentry.setTag('tenant.project_id', tenant.project_id);
  if (tenant.tenant_id) {
    Sentry.setTag('tenant.tenant_id', tenant.tenant_id);
  }
}
